"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcons = exports.StyledTitle = exports.StyledMenu = exports.StyledContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledContainer",
  componentId: "sc-14w792-0"
})(["padding-top:10px;position:absolute;top:30px;right:-102px;width:262px;z-index:11;@media only screen and (max-width:767px){right:0;}"]);

exports.StyledContainer = StyledContainer;

var StyledMenu = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledMenu",
  componentId: "sc-14w792-1"
})(["box-sizing:border-box;height:auto;max-height:459px;width:100%;border:1px solid #D7D7D7;border-radius:4px;background-color:#FFFFFF;box-shadow:0 20px 30px 0 rgba(0,0,0,0.1);z-index:2;padding:29px 34px;&:before{content:' ';position:absolute;left:131px;top:-8px;border:10px solid transparent;border-top:10px solid #FFFFFF;z-index:3;transform:rotate(180deg);@media only screen and (max-width:767px){right:10px;left:auto;}}"]);

exports.StyledMenu = StyledMenu;

var StyledTitle = _styledComponents["default"].h4.withConfig({
  displayName: "style__StyledTitle",
  componentId: "sc-14w792-2"
})(["color:#555555;font-size:10px;font-weight:500;line-height:14px;margin-bottom:0;text-transform:uppercase;"]);

exports.StyledTitle = StyledTitle;

var StyledIcons = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledIcons",
  componentId: "sc-14w792-3"
})(["display:flex;align-items:stretch;justify-content:flex-start;flex-wrap:wrap;margin-left:-8px;margin-right:-8px;"]);

exports.StyledIcons = StyledIcons;